<template>
  <div class="pd-b-20">
    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage">
        <div class="initial-load-animation">
          <div class="linkedin-image"></div>
          <div class="loading-bar">
            <div class="blue-bar"></div>
          </div>
        </div>
      </div>
    </transition>
    <div class="pd-10 level mg-t-20">
      <p class="title is-size-4-tablet is-size-5-mobile has-text-weight-normal">
        {{ $t("companyDashboard.viewDashboardButton") }}

        <a @click="openModalCreditScoring()" class="has-text-weight-semibold"
          ><span style="font-size: 14px"
            >{{ $t("companyDashboard.businessScoreButton") }}
          </span></a
        >

        <span
          class="textColorMain is-size-6 th flex-compamyName"
          :class="{ 'is-padding-left': widthMax > 768 }"
          v-if="
            getRule === 'admin' ||
            getRule === 'staff' ||
            getRule === 'exclusiveboard'
          "
          >{{ userDetail.organizeName }}</span
        >
      </p>
      <a @click="prevPage()">
        <p
          v-if="getRule !== 'startup' && pageStatus === 'company'"
          class="text-back-page backpage-color has-text-weight-semibold"
        >
          <i class="fas fa-arrow-left is-margin-right-sm"></i
          >{{ $t("message.btnBackToCompanyList") }}
        </p>
        <p
          v-if="
            getRule === 'admin' &&
            pageStatus === 'staff' &&
            pageStatus !== 'admin'
          "
          class="text-back-page backpage-color has-text-weight-semibold"
        >
          <i class="fas fa-arrow-left is-margin-right-sm"></i
          >{{ $t("message.btnBackToStaffList") }}
        </p>
      </a>
    </div>
    <div class="columns m-h-auto">
      <div v-if="getRule == 'startup'" class="column th is-size-5 pd-y-0"></div>
      <div
        v-if="getRule == 'startup'"
        class="column th has-text-right is-size-7 pd-y-0 is-flex is-justify-end is-align-center"
      >
        {{ $t("message.updatedAt") }} {{ new Date() | formatDate }}
        <span class="dashboard-startup">
          <span class="border-dropdown">
            <b-dropdown position="is-bottom-left">
              <button class="button dp-btn-noBg mg-r-15 mg-l-10" slot="trigger">
                <template>
                  <i class="fas fa-cogs has-text-grey-light text-name-user"></i>
                </template>
              </button>
              <b-dropdown-item
                @click="$store.commit('setResetDashboard', true)"
                class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
                has-link
              >
                <a class="dp-link has-text-centered"
                  ><i class="fas fa-redo mg-r-8"></i>
                  {{ $t("message.btnResetLayout") }}</a
                >
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
      </div>
    </div>

    <grid-layout
      :layout.sync="layout"
      :col-num="12"
      :row-height="110"
      :is-draggable="getRule === 'startup' && widthMax > 768 ? true : false"
      :is-resizable="getRule === 'startup' && widthMax > 768 ? true : false"
      :is-mirrored="false"
      :vertical-compact="true"
      :margin="[10, 10]"
      :use-css-transforms="true"
    >
      <div v-if="isLoadingPage === false">
        <grid-item
          v-for="item in layout"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
          :minW="item.minW"
          :minH="item.minH"
          drag-allow-from=".vue-draggable-handle"
          drag-ignore-from=".no-drag"
          @moved="updateItemLayout"
          @resized="updateItemLayout"
        >
          <ProductInformation
            v-if="renderInfomation"
            v-show="item.i === '0'"
            @cancelProduct="ModalProduct = false"
            @ModalEdit="(ModalProduct = true), setDataProductEdit()"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
            useBy="startup"
          />
          <BusinessInformation
            v-if="renderInfomation"
            v-show="item.i === '1'"
            @ModalEdit="(ModalInfomation = true), setDataBusinessEdit()"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
            useBy="startup"
          />

          <PerformanceSupport
            :activitysAll="propPerformanceSupport"
            v-show="item.i === '3'"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
            useBy="startup"
          />
          <InvestmentSupport
            v-show="item.i === '4'"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
            :tasksAllStartup="getTaskAllStartup"
            useBy="startup"
          />
          <Performance
            v-show="item.i === '5'"
            @openModalInfo="openModalInfo"
            @openIsDetailWorkToday="openIsDetailWorkToday"
            @openIsDetailWorkTodaySuccess="openIsDetailWorkTodaySuccess"
            :handle="getRule === 'startup' ? true : false"
            useBy="startup"
          />
          <BusinessGrowth
            v-show="item.i === '6'"
            :kpi="kpi"
            @openModalInfo="openModalInfo"
            :handle="getRule === 'startup' ? true : false"
            useBy="startup"
            :renderKpi="renderKpi"
            @changTap="changTap"
          />
        </grid-item>
      </div>
    </grid-layout>

    <b-modal
      :active.sync="isDetailWorkToday"
      :width="800"
      @close="closeModalActive(false)"
    >
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <p
              class="is-size-4 has-text-weight-normal has-text-left th is-marginless"
            >
              {{ $t("message.startedTaskDetailsHeader") }}
            </p>
            <hr class="mg-y-15" />
            <div class="pd-y-5">
              <p class="th is-size-5 has-text-weight-normal">
                {{ $t("message.startedTaskDetailsToday") }}
              </p>
              <div v-if="taskDoingToday.length > 0">
                <div v-for="(item, index) in taskDoingToday" :key="index">
                  <p class="pd-l-20 th">{{ index + 1 }}. {{ item.name }}</p>
                </div>
              </div>
              <div v-else>
                <p class="pd-l-10 th has-text-left is-size-6">
                  *** {{ $t("message.notFoundTask") }} ***
                </p>
              </div>
            </div>
            <div class="pd-y-5">
              <p class="th is-size-5 has-text-weight-normal">
                {{ $t("message.startedTaskDetailsFuture") }}
              </p>
              <div v-if="taskDoingTodayFuture.length > 0">
                <div v-for="(item, index) in taskDoingTodayFuture" :key="index">
                  <p class="pd-l-20 th">{{ index + 1 }}. {{ item.name }}</p>
                </div>
              </div>
              <div v-else>
                <p class="pd-l-10 th has-text-left is-size-6">
                  *** {{ $t("message.notFoundTask") }} ***
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      :active.sync="isDetailWorkTodaySuccess"
      :width="800"
      @close="closeModalActive(false)"
    >
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <p
              class="is-size-4 has-text-weight-normal has-text-left th is-marginless"
            >
              {{ $t("message.dashboardDoneTaskButton") }}
            </p>
            <hr class="mg-y-15" />
            <div class="pd-y-5">
              <p class="th is-size-5 has-text-weight-normal">
                {{ $t("message.completedTaskDetailsToday") }}
              </p>
              <div v-if="taskDoingTodaySuccess.length > 0">
                <div
                  v-for="(item, index) in taskDoingTodaySuccess"
                  :key="index"
                >
                  <p class="pd-l-20 th">{{ index + 1 }}. {{ item.name }}</p>
                </div>
              </div>
              <div v-else>
                <p class="pd-l-10 th has-text-left is-size-6">
                  *** {{ $t("message.notFoundTask") }} ***
                </p>
              </div>
            </div>
            <div class="pd-y-5">
              <p class="th is-size-5 has-text-weight-normal">
                {{ $t("message.completedTaskDetailsOverdue") }}
              </p>
              <div v-if="taskDoingPastSuccess.length > 0">
                <div v-for="(item, index) in taskDoingPastSuccess" :key="index">
                  <p class="pd-l-20 th">{{ index + 1 }}. {{ item.name }}</p>
                </div>
              </div>
              <div v-else>
                <p class="pd-l-10 th has-text-left is-size-6">
                  *** {{ $t("message.notFoundTask") }} ***
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      :active.sync="setmodalCreditScoring"
      :width="900"
      @close="closeModalActive(false)"
      class="modal-over-unset"
    >
      <CreditScoring />
    </b-modal>

    <b-modal
      :active.sync="isInfoMoal"
      :width="800"
      @close="closeModalActive(false)"
    >
      <infomodal :id="infoState" />
    </b-modal>

    <b-modal
      :active.sync="ModalInfomation"
      :width="1024"
      @close="closeModalActive(false)"
    >
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <BusinessInfo
              :edit="dataBusinessEdit"
              @cancelCompany="ModalInfomation = false"
              @resetCompany="getDetailComapny(), (ModalInfomation = false)"
            />
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      :active.sync="ModalProduct"
      :width="1024"
      @close="closeModalActive(false)"
    >
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <ProductInfo
              :edit="dataProductEdit"
              @cancelProduct="ModalProduct = false"
              @resetProduct="getDetailComapny(), (ModalProduct = false)"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import ProductInfo from "@/components/CompanyInfomation/ProductInfomation.vue";
import BusinessInfo from "@/components/CompanyInfomation/BusinessInfomation.vue";
import { HTTP, HTTPDynamic } from "../axios.js";
import CreditScoring from "@/components/CreditScoring.vue";
import VueGridLayout from "vue-grid-layout";
import ProductInformation from "./dashboard/ProductInformation.vue";
import BusinessInformation from "./dashboard/BusinessInformation.vue";
import PerformanceSupport from "./dashboard/PerformanceSupport.vue";
import Investment from "./dashboard/Investment.vue";
import InvestmentSupport from "./dashboard/InvestmentSupport.vue";
import Performance from "./dashboard/Performance.vue";
import BusinessGrowth from "./dashboard/BusinessGrowth.vue";
import infomodal from "./infomodal";

export default {
  components: {
    ProductInfo,
    BusinessInfo,
    BusinessInformation,
    CreditScoring,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    ProductInformation,
    PerformanceSupport,
    Investment,
    InvestmentSupport,
    Performance,
    BusinessGrowth,
    infomodal,
  },
  watch: {
    resetDashboard() {
      if (this.resetDashboard == true) {
        this.$store.commit("setResetDashboard", false);
        this.resetItemLayout();
      }
    },
  },
  computed: {
    setmodalCreditScoring: {
      get() {
        return this.$store.getters.setmodalCreditScoring
          .isOpenModalCreditScoring;
      },
      set(data) {
        this.$store.commit("setmodalCreditScoring", false);
        this.$store.commit("setModalActive", false);
        return this.$store.state.isOpenModalCreditScoring;
      },
    },
    resetDashboard() {
      return this.$store.state.resetDashboard;
    },
    pageStatus() {
      return this.$store.state.pageStatus;
    },
    getRule() {
      return this.$store.state.rule;
    },
    user() {
      return this.$store.state.user;
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
    batch() {
      return this.$store.state.batch;
    },
    token() {
      return this.$store.state.token;
    },
    taskDoingToday() {
      let filter = this.$store.getters.tasks.filter(
        (item) =>
          new Date(item.startDate).toLocaleDateString() ===
          new Date().toLocaleDateString()
      );
      return filter;
    },
    taskDoingTodayFuture() {
      let now = new Date().setHours(0, 0, 0, 0);
      let future = new Date().setHours(0, 0, 0, 0) + 86400000 * 7;
      let filter = this.$store.getters.tasks.filter(
        (item) =>
          new Date(item.startDate).getTime() > new Date(now).getTime() &&
          new Date(item.startDate).getTime() <= new Date(future).getTime()
      );
      return filter;
    },
    taskDoingTodaySuccess() {
      let filter = this.$store.getters.tasks.filter(
        (item) =>
          new Date(item.endDate).toLocaleDateString() ===
          new Date().toLocaleDateString()
      );
      return filter;
    },
    taskDoingPastSuccess() {
      let filter = this.$store.getters.tasks.filter(
        (item) =>
          new Date().setHours(0, 0, 0, 0) > new Date(item.endDate).getTime() &&
          item.status !== 3
      );
      return filter;
    },
    categories() {
      return this.$store.state.categories;
    },
    startUpActivity() {
      return this.$store.state.startUpActivity;
    },
    activitysAll() {
      return this.$store.state.activitysAll;
    },
    taskPendingRequest() {
      if (this.getRule === "startup") {
        return this.taskPendingRequestInVisible;
      } else {
        return this.taskPendingRequestStaffAdmin;
      }
    },
    taskApproveAmount() {
      if (this.getRule === "startup") {
        return this.taskApproveAmountInVisible;
      } else {
        return this.taskApproveAmountStaffAdmin;
      }
    },
    taskPendingRequestStaffAdmin() {
      let amount = 0;
      let tasks =
        typeof this.tasksAllStartup !== "undefined"
          ? this.tasksAllStartup
          : this.$store.getters.tasks;
      tasks.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus !== 5 &&
          item.fundStatus !== 0 &&
          item.fundStatus !== 1
        ) {
          amount = amount + item.fundAmount;
        }
      });
      return amount;
    },
    taskPendingRequestInVisible() {
      let amount = 0;
      this.$store.getters.taskInVisible.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus !== 5 &&
          item.fundStatus !== 0 &&
          item.fundStatus !== 1
        ) {
          amount = amount + item.fundAmount;
        }
      });

      return amount;
    },
    taskApproveAmountStaffAdmin() {
      let amount = 0;
      let tasks =
        typeof this.tasksAllStartup !== "undefined"
          ? this.tasksAllStartup
          : this.$store.getters.tasks;
      tasks.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus === 5
        ) {
          amount = amount + item.approveAmount;
        }
      });
      return amount;
    },
    tasksAll() {
      if (this.getRule === "startup") {
        let filter = this.$store.getters.tasks.filter(
          (item) => item.fundStatus !== 4
        );
        return filter;
      } else {
        let task =
          typeof this.$store.getters.tasks !== "undefined"
            ? this.$store.getters.tasks
            : [];
        let filter = task.filter((item) => item.fundStatus !== 4);
        return filter;
      }
    },
    taskApproveAmountInVisible() {
      let amount = 0;
      this.$store.getters.taskInVisible.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus === 5
        ) {
          amount = amount + item.approveAmount;
        }
      });

      return amount;
    },
  },
  data() {
    return {
      renderInfomation: true,
      ModalProduct: false,
      ModalInfomation: false,
      widthMax: window.innerWidth,
      isLoadingPage: false,
      isDetailWorkToday: false,
      isDetailWorkTodaySuccess: false,
      kpi: {},
      layout: [],
      isInfoMoal: false,
      infoState: "",
      renderKpi: false,
      dataBusinessEdit: {},
      dataProductEdit: {},
      propPerformanceSupport: [],
    };
  },
  async mounted() {
    this.$store.commit("setPageNavActivity", "dashboard");
    this.isLoadingPage = true;
    await this.fetchKpiAll();
    await this.dataPerformanceSupport();
    await this.fetchDataPage();
    setTimeout(() => {
      this.fetchLayout();
    }, 2000);
  },
  destroyed() {
    this.$store.commit("setPageNavActivity", "");
  },
  methods: {
    getTaskAllStartup() {
      if ((this.getRule = !"startup")) {
        return this.tasksAllStartup;
      } else {
        return [];
      }
    },
    dataPerformanceSupport() {
      if (this.getRule === "startup") {
        this.propPerformanceSupport = this.$store.state.activitysAll;
      } else {
        this.propPerformanceSupport = this.$store.state.activitysAll;
      }
    },
    async getDetailComapny() {
      this.isLoadingPage = true;
      this.renderInfomation = false;
      let data = {
        batchId: this.batch._id,
      };
      let prosuccess = false;
      let businesssuccess = false;
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post("/get/business/by/batch", data).then((res) => {
        //console.log('/get/business/by/batch',res)
        if (res.data.success) {
          Object.keys(res.data.obj).forEach((key) => {
            let obj = {
              key: key == "_id" ? "businessId" : key,
              value: res.data.obj[key],
            };
            this.$store.commit("updateUser", obj);
          });
        }
      });

      await HTTP.post("/get/product/by/batch", data).then((res) => {
        //console.log('/get/product/by/batch',res)
        if (res.data.success) {
          let dataFilter = res.data.obj[0].batchs.filter(
            (search) => search.batchId == this.batch._id
          );
          let dataObj = [
            {
              key: "production",
              value: res.data.obj[0].production,
            },
            {
              key: "websiteOfProduct",
              value: res.data.obj[0].websiteOfProduct,
            },
            {
              key: "productBatchs",
              value:
                dataFilter.length > 0 ? dataFilter[0] : res.data.obj[0].batchs,
            },
            {
              key: "productId",
              value: res.data.obj[0]._id,
            },
            {
              key: "From",
              value: "Dashboard",
            },
          ];
          dataObj.map((data) => {
            this.$store.commit("updateUser", data);
          });

          Object.keys(res.data.obj[0].batchs[0]).forEach((key) => {
            let obj = {
              key: key,
              value: res.data.obj[0].batchs[0][key],
            };
            this.$store.commit("updateUser", obj);
          });
          this.isLoadingPage = false;
        } else {
          prosuccess = true;
        }
        this.renderInfomation = true;
      });
    },
    setDataBusinessEdit() {
      this.dataBusinessEdit.nameOfBusiness =
        this.getRule == "startup"
          ? this.user.organizeName
          : this.userDetail.organizeName;
      this.dataBusinessEdit.telephoneBusinessTeam =
        this.getRule == "startup"
          ? this.user.telephoneBusinessTeam
          : this.userDetail.telephoneBusinessTeam;
      this.dataBusinessEdit.batchs =
        this.getRule == "startup" ? this.user.batchs : this.userDetail.batchs;
      this.dataBusinessEdit._id =
        this.getRule == "startup"
          ? this.user.businessId
          : this.userDetail.businessId;
      this.dataBusinessEdit.websiteBusiness =
        this.getRule == "startup"
          ? this.user.websiteBusiness
          : this.userDetail.websiteBusiness;
      this.dataBusinessEdit.address =
        this.getRule == "startup" ? this.user.address : this.userDetail.address;
      this.dataBusinessEdit.postcode =
        this.getRule == "startup"
          ? this.user.postcode
          : this.userDetail.postcode;
      this.dataBusinessEdit.subDistrict =
        this.getRule == "startup"
          ? this.user.subDistrict
          : this.userDetail.subDistrict;
      this.dataBusinessEdit.cityDistrict =
        this.getRule == "startup"
          ? this.user.cityDistrict
          : this.userDetail.cityDistrict;
      this.dataBusinessEdit.province =
        this.getRule == "startup"
          ? this.user.province
          : this.userDetail.province;
      this.dataBusinessEdit.country =
        this.getRule == "startup" ? this.user.country : this.userDetail.country;
      this.dataBusinessEdit.bizGroup =
        this.getRule == "startup"
          ? this.user.bizGroup
          : this.userDetail.bizGroup;
      this.dataBusinessEdit.bizModel =
        this.getRule == "startup"
          ? this.user.bizModel
          : this.userDetail.bizModel;
      this.dataBusinessEdit.organizeLogo =
        this.getRule == "startup"
          ? this.user.organizeLogo
          : this.userDetail.organizeLogo;
    },
    setDataProductEdit() {
      this.dataProductEdit._id =
        this.getRule == "startup"
          ? this.user.productId
          : this.userDetail.productId;
      this.dataProductEdit.production =
        this.getRule == "startup"
          ? this.user.production
          : this.userDetail.production;
      this.dataProductEdit.typeOfBusiness =
        this.getRule == "startup"
          ? this.user.typeOfBusiness
          : this.userDetail.typeOfBusiness;
      this.dataProductEdit.levelOfbusiness =
        this.getRule == "startup"
          ? this.user.levelOfbusiness
          : this.userDetail.levelOfbusiness;
      this.dataProductEdit.productBatchs =
        this.getRule == "startup"
          ? this.user.productBatchs
          : this.userDetail.productBatchs;
      this.dataProductEdit.websiteOfProduct =
        this.getRule == "startup"
          ? this.user.websiteOfProduct
          : this.userDetail.websiteOfProduct;
    },
    closeModalActive(status) {
      this.$store.commit("setModalActive", status);
    },
    changTap() {
      this.renderKpi = false;
      setTimeout(() => {
        this.renderKpi = true;
      }, 100);
    },
    linkDrawDown() {
      //let text = JSON.stringify(this.user.detailUser[0])
      let obj = {};
      obj["userIdInteg"] = this.user._id;
      obj["email"] = this.user.email;
      obj["projectDetail"] = [
        {
          batchId: this.batch._id,
          batchName: this.batch.name,
          fiscalYear: this.batch.fiscalYear,
          contractNumber: "",
          projectId: "",
          projectNameTh: "",
          projectNameEn: "",
          nameOfBusiness: this.user.nameOfBusiness,
          titleName: "",
          name: this.user.name,
          surname: this.user.surname,
          amountPhase: "",
        },
      ];
      obj["userLevel"] = this.user.userLevel;
      //console.log('obj',obj)
      var jwt = require("jsonwebtoken");
      var secret = "dFvsdd125ssE";
      var token = jwt.sign(
        {
          token: this.user.token,
          obj: obj,
        },
        secret
      );
      window.open("localhost:8080/token/" + token, "_blank");
    },
    openModalCreditScoring() {
      this.$store.commit("setmodalCreditScoring", true);
      this.$store.commit("setModalActive", true);
    },
    getPercentGrowth(last, before) {
      let num = last - before;
      let sum = num / before;
      let percent = sum * 100;
      if (isFinite(percent) === true) {
        return Number(percent.toFixed(2));
      } else {
        return 0;
      }
    },
    prevPage() {
      if (this.pageStatus === "company" || this.getRule == "exclusiveboard") {
        this.$router.push("/startup-list");
      } else {
        this.$router.push("/staff-detail");
      }
    },
    fetchKpiAll() {
      this.kpi = {};
      let obj = {
        roleId:
          this.getRule === "exclusiveboard"
            ? this.startUpActivity.batchId
            : this.batch._id,
        companyId:
          this.getRule === "startup"
            ? this.user._id
            : this.getRule === "exclusiveboard"
            ? this.startUpActivity.startUpId
            : this.userDetail.startUpId,
      };

      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTPDynamic.post(`api/get/all/kpi`, obj)
        .then((res) => {
          // console.log("api/get/all/kpi",res)
          if (res.data.success && res.data.obj.length > 0) {
            Object.keys(res.data.obj[res.data.obj.length - 1].kpi).forEach(
              (key) => {
                let count = 1;
                let futureCount = 1;
                let q = 1;
                let repeatDate = new Date(2019, 0, 1);

                let repeatStartNum = repeatDate.getMonth();
                let repeatDateFuture = new Date(
                  res.data.obj[res.data.obj.length - 1].kpi[
                    key
                  ].repeat.repeatStart
                );

                repeatDateFuture = new Date(
                  repeatDateFuture.setMonth(
                    repeatStartNum +
                      res.data.obj[res.data.obj.length - 1].kpi[key].repeat
                        .everyRepeat *
                        futureCount,
                    1
                  )
                );
                let repeatStartNumFuture = repeatDateFuture.getMonth();
                const repeatDateFutureConst = repeatDateFuture;

                this.kpi[key] = {
                  name: res.data.obj[res.data.obj.length - 1].kpi[key]
                    .nameLabel,
                  label: [],
                  value: [],
                  lastUpdate: [],
                  percent: 0,
                };
                // console.log("repeatDate",repeatDate)

                while (repeatDate.getTime() <= new Date().getTime()) {
                  // let label = new Date(repeatDate).getDate()+' '+this.getMothFormat(new Date(repeatDate).getMonth())+''+new Date(repeatDate).getFullYear().toString().slice(2,4)
                  let updatedAt =
                    res.data.obj[res.data.obj.length - 1].updatedAt;

                  let value = [];

                  for (let index = 0; index < res.data.obj.length; index++) {
                    if (
                      new Date(
                        res.data.obj[index].kpi[key].lastUpdate
                      ).getTime() >= repeatDate.getTime() &&
                      new Date(
                        res.data.obj[index].kpi[key].lastUpdate
                      ).getTime() < repeatDateFuture.getTime()
                    ) {
                      value.push({
                        data: res.data.obj[index].kpi[key].input,
                        date: new Date(
                          res.data.obj[index].kpi[key].lastUpdate
                        ).getTime(),
                      });
                    }
                  }

                  if (q > 4) {
                    q = 1;
                  }
                  if (value.length > 0) {
                    let sort = value.sort((a, b) => {
                      const modifier = -1;
                      if (a.date < b.date) return -1 * modifier;
                      if (a.date > b.date) return 1 * modifier;
                      return 0;
                    });

                    let label =
                      "Q" +
                      q +
                      "(" +
                      new Date(sort[0].date).getFullYear() +
                      ")";

                    this.kpi[key].label.push(label);
                    let lastUpdate =
                      new Date(sort[0].date).getDate() +
                      " " +
                      this.getMothFormat(new Date(sort[0].date).getMonth()) +
                      "" +
                      new Date(sort[0].date)
                        .getFullYear()
                        .toString()
                        .slice(2, 4);

                    this.kpi[key].lastUpdate.push(lastUpdate);
                    this.kpi[key].value.push(
                      sort[0].data !== null ? sort[0].data : 0
                    );
                  } else {
                    let label =
                      "Q" + q + "(" + new Date(repeatDate).getFullYear() + ")";
                    this.kpi[key].label.push(label);
                    let lastUpdate =
                      new Date(repeatDate).getDate() +
                      " " +
                      this.getMothFormat(new Date(repeatDate).getMonth()) +
                      "" +
                      new Date(repeatDate).getFullYear().toString().slice(2, 4);
                    this.kpi[key].lastUpdate.push(lastUpdate);
                    this.kpi[key].value.push(0);
                  }

                  repeatDate = new Date(
                    res.data.obj[res.data.obj.length - 1].kpi[
                      key
                    ].repeat.repeatStart
                  );
                  repeatDate.setMonth(
                    repeatStartNum +
                      res.data.obj[res.data.obj.length - 1].kpi[key].repeat
                        .everyRepeat *
                        count,
                    1
                  );
                  repeatDateFuture = new Date(
                    res.data.obj[res.data.obj.length - 1].kpi[
                      key
                    ].repeat.repeatStart
                  );
                  repeatDateFuture.setMonth(
                    repeatStartNumFuture +
                      res.data.obj[res.data.obj.length - 1].kpi[key].repeat
                        .everyRepeat *
                        futureCount,
                    1
                  );

                  q++;
                  count++;
                  futureCount++;
                }

                this.kpi[key].percent = this.getPercentGrowth(
                  this.kpi[key].value[this.kpi[key].value.length - 1],
                  this.kpi[key].value[this.kpi[key].value.length - 2]
                );
              }
            );
          }
          //console.log("kpi",this.kpi)
          this.renderKpi = true;
        })
        .catch((e) => {
          console.log("api/get/all/kpi/error", e);
        });
    },
    getMothFormat(month) {
      let text = "";
      switch (month) {
        case 0:
          text = "Jan'";
          break;
        case 1:
          text = "Feb'";
          break;
        case 2:
          text = "Mar'";
          break;
        case 3:
          text = "Apr'";
          break;
        case 4:
          text = "May'";
          break;
        case 5:
          text = "Jun'";
          break;
        case 6:
          text = "Jul'";
          break;
        case 7:
          text = "Aug'";
          break;
        case 8:
          text = "Sep'";
          break;
        case 9:
          text = "Oct'";
          break;
        case 10:
          text = "Nov'";
          break;
        case 11:
          text = "Dec'";
          break;
        default:
          break;
      }
      return text;
    },
    async fetchDataPage() {
      const data = {
        startUpId:
          this.getRule === "startup"
            ? this.user._id
            : this.getRule === "exclusiveboard"
            ? this.startUpActivity.startUpId
            : this.userDetail.startUpId,
        batchId:
          this.getRule === "exclusiveboard"
            ? this.startUpActivity.batchId
            : this.batch._id,
        token: this.token,
      };

      await this.$store.dispatch("setCategorie", data);
      await this.$store.dispatch("loadData", data);
    },
    openModalInfo(id) {
      this.$store.commit("setModalActive", true);
      this.infoState = id;
      this.isInfoMoal = true;
    },
    openIsDetailWorkToday(status) {
      this.$store.commit("setModalActive", true);
      this.isDetailWorkToday = true;
    },
    openIsDetailWorkTodaySuccess(status) {
      this.$store.commit("setModalActive", true);
      this.isDetailWorkTodaySuccess = true;
    },
    resetItemLayout() {
      const sizeWindows = [
        //Product Information
        { x: 6, y: 0, w: 6, h: 3, i: "0", minW: 6, minH: 3 },
        //Business Information
        { x: 0, y: 0, w: 6, h: 3, i: "1", minW: 6, minH: 3 },
        //Investment
        // {x:0,y:1,w:6,h:(this.taskPendingRequest == 0 || this.taskApproveAmount == 0) ? 3 : 5,i:"2",minW:6,minH:3},
        //Performance Support
        {
          x: 0,
          y: 2,
          w: 12,
          h:
            this.categories.length < 5 || this.activitysAll.length == 0
              ? 3
              : this.categories.length <= 6
              ? 4
              : this.categories.length <= 10
              ? 4
              : this.categories.length < 16
              ? 5
              : this.categories.length < 22
              ? 6
              : this.categories.length < 21
              ? 7
              : 8,
          i: "3",
          minW: 12,
          minH: 1,
        },
        //Investment Support
        {
          x: 0,
          y: 4,
          w: 12,
          h:
            this.categories.length < 5 ||
            (this.taskPendingRequest == 0 && this.taskApproveAmount == 0)
              ? 3
              : this.categories.length <= 6
              ? 4
              : this.categories.length <= 10
              ? 5
              : this.categories.length < 13
              ? 6
              : this.categories.length < 16
              ? 7
              : this.categories.length < 22
              ? 9
              : 10,
          i: "4",
          minW: 12,
          minH: 3,
        },
        //Performance
        {
          x: 0,
          y: 1,
          w: 12,
          h: this.tasksAll.length > 0 ? 5 : 3,
          i: "5",
          minW: 12,
          minH: 3,
        },
        //Business Growth
        {
          x:
            this.taskPendingRequest == 0 &&
            this.taskApproveAmount == 0 &&
            this.categories.length < 13
              ? 0
              : this.categories.length < 15 &&
                this.taskPendingRequest == 0 &&
                this.taskApproveAmount == 0
              ? 6
              : 0,
          y:
            this.categories.length < 15 &&
            this.taskPendingRequest == 0 &&
            this.taskApproveAmount == 0
              ? 5
              : 6,
          w: 12,
          h: typeof this.kpi.Employment === "undefined" ? 3 : 5,
          i: "6",
          minW: 6,
          minH: 3,
        },
        // {x:6,y:3,w:6,h:3,i:"7",minW:6,minH:3}
      ];

      let obj = {
        batchId: this.batch._id,
        objects: sizeWindows,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`api/save/drang/and/drop`, obj)
        .then((res) => {
          this.$store.commit("setResetDashboard", false);
          this.fetchLayout();
        })
        .catch((e) => {
          console.log("api/save/drang/and/drop/error", e);
        });
    },
    updateItemLayout() {
      let itemLayout = [];
      this.layout.map((item) => {
        itemLayout.push({
          x: item.x,
          y: item.y,
          w: item.w,
          h: item.h,
          i: item.i,
          properties: {},
        });
      });

      let obj = {
        batchId: this.batch._id,
        objects: itemLayout,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`api/save/drang/and/drop`, obj)
        .then((res) => {})
        .catch((e) => {
          console.log("api/save/drang/and/drop/error", e);
        });
    },
    fetchLayout() {
      const sizeWindows = [
        //Product Information
        { x: 6, y: 0, w: 6, h: 3, i: "0", minW: 6, minH: 3 },
        //Business Information
        { x: 0, y: 0, w: 6, h: 3, i: "1", minW: 6, minH: 3 },
        //Investment
        // {x:0,y:1,w:6,h:(this.taskPendingRequest == 0 || this.taskApproveAmount == 0) ? 3 : 5,i:"2",minW:6,minH:3},
        //Performance Support
        {
          x: 0,
          y: 2,
          w: 12,
          h:
            this.categories.length < 5 || this.activitysAll.length == 0
              ? 3
              : this.categories.length <= 6
              ? 4
              : this.categories.length <= 10
              ? 4
              : this.categories.length < 16
              ? 5
              : this.categories.length < 22
              ? 6
              : this.categories.length < 21
              ? 7
              : 8,
          i: "3",
          minW: 12,
          minH: 1,
        },
        //Investment Support
        {
          x: 0,
          y: 3,
          w: 12,
          h:
            this.categories.length < 5 ||
            (this.taskPendingRequest == 0 && this.taskApproveAmount == 0)
              ? 3
              : this.categories.length <= 6
              ? 4
              : this.categories.length <= 10
              ? 5
              : this.categories.length < 13
              ? 6
              : this.categories.length < 16
              ? 7
              : this.categories.length < 22
              ? 9
              : 10,
          i: "4",
          minW: 12,
          minH: 3,
        },
        //Performance
        {
          x: 0,
          y: 1,
          w: 12,
          h: this.tasksAll.length > 0 ? 5 : 3,
          i: "5",
          minW: 6,
          minH: 3,
        },
        //Business Growth
        {
          x:
            this.taskPendingRequest == 0 &&
            this.taskApproveAmount == 0 &&
            this.categories.length < 13
              ? 0
              : this.categories.length < 15 &&
                this.taskPendingRequest == 0 &&
                this.taskApproveAmount == 0
              ? 6
              : 0,
          y:
            this.categories.length < 15 &&
            this.taskPendingRequest == 0 &&
            this.taskApproveAmount == 0
              ? 5
              : 6,
          w: 12,
          h: typeof this.kpi.Employment === "undefined" ? 3 : 5,
          i: "6",
          minW: 6,
          minH: 3,
        },
        // {x:6,y:3,w:6,h:3,i:"7",minW:6,minH:3}
      ];

      const sizeMobile = [
        { x: 0, y: 0, w: 12, h: 4, i: "0" },
        { x: 0, y: 1, w: 12, h: 4, i: "1" },
        // {x:0,y:2,w:12,h:(this.categories.length < 7)?4:9,i:"2"},
        {
          x: 0,
          y: 3,
          w: 12,
          h:
            this.categories.length < 7
              ? 6
              : this.categories.length < 8
              ? 7
              : this.categories.length < 14
              ? 10
              : 12,
          i: "3",
        },
        {
          x: 0,
          y: 4,
          w: 12,
          h:
            this.categories.length < 7
              ? 7
              : this.categories.length < 8
              ? 8
              : this.categories.length < 14
              ? 11
              : 12,
          i: "4",
        },
        { x: 0, y: 5, w: 12, h: 6, i: "5" },
        { x: 0, y: 6, w: 12, h: 6, i: "6" },
        // {x:0,y:7,w:12,h:6,i:"7"}
      ];

      if (this.getRule == "startup") {
        let obj = {
          batchId: this.batch._id,
          userId:
            this.getRule === "startup"
              ? this.user._id
              : this.userDetail.startUpId,
        };
        HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        HTTP.post(`api/get/drag/and/drop`, obj)
          .then((res) => {
            //console.log("res",res)
            if (res.data.success) {
              let itemLayout = [];
              res.data.obj.objects.map((item) => {
                itemLayout.push({
                  x: item.x,
                  y: item.y,
                  w: item.w,
                  h: item.h,
                  i: item.i,
                  minW: getMinW(item.i),
                  minH: getMinH(item.i),
                });
              });
              //console.log('itemLayout',itemLayout)
              this.layout = this.widthMax > 768 ? itemLayout : sizeMobile;
              this.isLoadingPage = false;
            } else {
              this.isLoadingPage = false;
              this.layout = this.widthMax > 768 ? sizeWindows : sizeMobile;
            }

            function getMinW(i) {
              switch (i) {
                case "0":
                  return 6;
                  break;
                case "1":
                  return 6;
                  break;
                case "2":
                  return 6;
                  break;
                case "3":
                  return 6;
                  break;
                case "4":
                  return 6;
                  break;
                case "5":
                  return 6;
                  break;

                default:
                  break;
              }
            }
            function getMinH(i) {
              switch (i) {
                case "0":
                  return 2;
                  break;
                case "1":
                  return 3;
                  break;
                case "2":
                  return 3;
                  break;
                case "3":
                  return 4;
                  break;
                case "4":
                  return 6;
                  break;
                case "5":
                  return 6;
                  break;

                default:
                  break;
              }
            }
          })
          .catch((e) => {
            console.log("api/get/drag/and/drop/error", e);
          });
      } else {
        this.isLoadingPage = false;
        this.layout = this.widthMax > 768 ? sizeWindows : sizeMobile;
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .flex-compamyName {
    display: flex;
    margin: 1rem 0;
  }
}
</style>
